import * as React from 'react';
import { intlShape } from 'react-intl';
import { AccountNumberPostalCodeLogin } from '@src/app/login/components';
import { EmailPostalCodeLogin } from '@src/app/login/components';
import { NameAddressLogin } from '@src/app/login/components';
import { Field, reduxForm } from 'redux-form';
import { SimplerSelectV2 } from '@src/app/_global/components/form-elements';
import { AuthState } from '@src/app/login/reducers';
import { Row, Col } from 'reactstrap';
import { LoginTabs } from '@src/app/login/types';
interface WeakLoginProps {
  auth: AuthState;
  openTab: any;
  signInData: any;
  isPurgatory: boolean;
  dispatch: any;
}

interface TabProps {
  openTab: string;
  name: string;
  title: string;
  index: any;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => any;
}
interface Option {
  label: string;
  value: string;
}
interface State {
  openTab: any;
  enabledWeakLogins: [];
  weakLoginOptions:  Array<Option> ;
  isPurgatory: boolean;
}
class WeakLoginFormOptions extends React.Component<WeakLoginProps> {
  state: State = {
    openTab: LoginTabs.accountPostalCode,
    enabledWeakLogins: [],
    weakLoginOptions: [],
    isPurgatory: false,
  };

  // tslint:disable-next-line:member-ordering
  static contextTypes = {
    intl: intlShape,
  };

  constructor(props: any) {
    super(props);
  }

  handleOptionChange = (evt: Option) => {
    this.setState({
      openTab: evt.value,
    });
  }
  // tslint:disable-next-line:no-shadowed-variable
  formatTabTitle = (messageId, descriptionm, defaultm, context) => {
    const title = context.intl.formatMessage({
      id: messageId,
      description: descriptionm,
      defaultMessage: defaultm,
    });
    return title;
  }
  componentWillMount () {
    const { signInData, isPurgatory } = this.props;
    let weakLoginOptions: Array<Option> = [];
    let enabledWeakLogins: Array<string> = [];
    let firstEnabledWeakLogin = '';
    let openTabIndex = 0;
    weakLoginOptions.push({label: 'Find your account', value: ''});
    if (signInData.AccountNumberPostalCodeEnabled) {
      enabledWeakLogins.push(LoginTabs.accountPostalCode);
      weakLoginOptions.push({label: 'Account Number', value: LoginTabs.accountPostalCode});
      openTabIndex = signInData.DefaultLogin === 'AccountNumberPostalCode' ? enabledWeakLogins.length - 1 : openTabIndex;
    }
    if (signInData.EmailPostalCodeEnabled) {
      enabledWeakLogins.push(LoginTabs.emailPostalCode);
      weakLoginOptions.push({label: 'Email', value: LoginTabs.emailPostalCode});
      openTabIndex = signInData.DefaultLogin === 'EmailPostalCode' ? enabledWeakLogins.length - 1 : openTabIndex;
    }
    if (signInData.NameAddressEnabled) {
      enabledWeakLogins.push(LoginTabs.nameAndAddress);
      weakLoginOptions.push({label: 'Name and Address', value: LoginTabs.nameAndAddress});
      openTabIndex = signInData.DefaultLogin === 'NameAddress' ? enabledWeakLogins.length - 1 : openTabIndex;
    }

    let defaultIsEnabled = false;
    switch (signInData.DefaultLogin) {
      case 'AccountNumberPostalCode':
        defaultIsEnabled = signInData.AccountNumberPostalCodeEnabled;
        break;  
      case 'EmailPostalCode':
        defaultIsEnabled = signInData.EmailPostalCodeEnabled;
        break;  
      case 'NameAddress':
        defaultIsEnabled = signInData.NameAddressEnabled;
        break;  
      default:
        break;
    }

    if (enabledWeakLogins.length === 1 || defaultIsEnabled) {
      firstEnabledWeakLogin = enabledWeakLogins[openTabIndex];
    } else {
      openTabIndex = (isPurgatory ? 0 : -1);
      firstEnabledWeakLogin = enabledWeakLogins[openTabIndex];
    }
    this.setState({openTab: firstEnabledWeakLogin, enabledWeakLogins: enabledWeakLogins, weakLoginOptions: weakLoginOptions});
  }

  componentWillReceiveProps({ openTab }: WeakLoginProps) {
    if (openTab != null && openTab !== this.props.openTab) {
      this.setState({ openTab });
    }
  }

  render() {
    const { signInData } = this.props;
    let loginSelection = this.state.weakLoginOptions.find(opt => opt.value === this.state.openTab);
    return (
 
      <div className="week-login-card" role="group">
        {(this.state.enabledWeakLogins.length > 1  ) && (
          <form className="login-selection-type">
            <div className="login-select">
              <Field
                name="LoginChoice"
                component={SimplerSelectV2}
                options={this.state.weakLoginOptions}
                onChange={this.handleOptionChange}
                ariaLabel="Login Choice"
                defaultOption={loginSelection ? loginSelection : this.state.weakLoginOptions[0]}
              />
            </div>
          </form>
        )}
        <Row className="flexContainer mb-4">
          <Col xs={12} sm={12} md={12}>
            {(() => {
              switch (this.state.openTab) {
                case LoginTabs.accountPostalCode:
                  return <AccountNumberPostalCodeLogin  signInData={signInData} />;
                case LoginTabs.emailPostalCode:
                  return <EmailPostalCodeLogin  signInData={signInData} />;
                case LoginTabs.nameAndAddress:
                  return <NameAddressLogin  signInData={signInData} />;
                default:
                  return null;
              }
            })()}
          </Col>
        </Row>
      </div>
    );
  }
}
const WeakLoginForm = reduxForm({
  form: 'login-options',
  forceUnregisterOnUnmount: true,
})(WeakLoginFormOptions);

export const WeakLogin = WeakLoginForm;
